import {FC} from 'react';

export const StorePickupSelectorOptionIcon: FC<{height?: string; width?: string}> = ({
  height = '33px',
  width = '33px'
}) => (
  <svg width={width} height={height} viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.9043 7.09766V26.5075H16.0682V16.8026V7.09766H1.9043Z" fill="#077769" />
    <path
      d="M13.9707 7.09766H31.8068V26.5075H29.7084V15.0326C29.7084 14.4167 29.2091 13.9173 28.5931 13.9173H22.8887H17.1843C16.5684 13.9173 16.0691 14.4167 16.0691 15.0326V26.5075H15.5445H13.9707V7.09766Z"
      fill="#229C8B"
    />
    <path
      d="M0.855469 7.48524C0.855469 6.9041 1.32793 6.43372 1.90906 6.43628L31.8111 6.5678C32.3886 6.57035 32.8555 7.03924 32.8555 7.61677C32.8555 8.19791 32.383 8.66829 31.8019 8.66574L1.89983 8.53421C1.3223 8.53167 0.855469 8.06277 0.855469 7.48524Z"
      fill="#077769"
    />
    <path
      d="M17.6426 16.5375C17.6426 15.958 18.1123 15.4883 18.6918 15.4883H20.7901C21.3696 15.4883 21.8393 15.958 21.8393 16.5375V18.6358C21.8393 19.2153 21.3696 19.685 20.7901 19.685H18.6918C18.1123 19.685 17.6426 19.2153 17.6426 18.6358V16.5375Z"
      fill="#FA4147"
    />
    <path
      d="M17.6426 22.3089C17.6426 21.7295 18.1123 21.2598 18.6918 21.2598H20.7901C21.3696 21.2598 21.8393 21.7295 21.8393 22.3089V24.4073C21.8393 24.9868 21.3696 25.4565 20.7901 25.4565H18.6918C18.1123 25.4565 17.6426 24.9868 17.6426 24.4073V22.3089Z"
      fill="#FA4147"
    />
    <path
      d="M23.9375 22.3089C23.9375 21.7295 24.4072 21.2598 24.9867 21.2598H27.085C27.6645 21.2598 28.1342 21.7295 28.1342 22.3089V24.4073C28.1342 24.9868 27.6645 25.4565 27.085 25.4565H24.9867C24.4072 25.4565 23.9375 24.9868 23.9375 24.4073V22.3089Z"
      fill="#FA4147"
    />
    <path
      d="M23.9375 16.5375C23.9375 15.958 24.4072 15.4883 24.9867 15.4883L27.085 15.4883C27.6645 15.4883 28.1342 15.958 28.1342 16.5375V18.6358C28.1342 19.2153 27.6645 19.685 27.085 19.685H24.9867C24.4072 19.685 23.9375 19.2153 23.9375 18.6358V16.5375Z"
      fill="#FA4147"
    />
  </svg>
);
